import React, { useEffect, useRef } from 'react';
import { Box, IconButton, InputAdornment, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

import { ButtonUI, InputUI } from '../../Interface';

const ItemOutgoing = ({
  itemFilter,
  onItemFilterChange,
  onSearch,
  itemInputRef,
  identifiedItem,
  identifiedQty,
  onIdentifiedQtyChange,
  onIdentifiedQtyBlur,
  identifiedQtyUnitCode,
  quantityInputStep,
  onConfirmItem,
  onClearIdentified,
  identifiedStockQty,
  alreadyRecordedQty,
  openQty,
  isOverStockLimit,
}) => {
  const qtyInputRef = useRef(null);

  useEffect(() => {
    if (!identifiedItem) return;
    qtyInputRef.current?.focus?.();
  }, [identifiedItem]);

  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 2,
        p: 1.5,
        bgcolor: 'grey.100',
        mt: 1.5,
      }}
    >
      <Box sx={{ bgcolor: 'white' }}>
        <InputUI
          autoFocus
          fullWidth
          size="small"
          placeholder="Vonalkód / cikkszám"
          value={itemFilter}
          inputRef={itemInputRef}
          onChange={(e) => onItemFilterChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              onSearch();
            }
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton size="small" edge="end" aria-label="Keresés" onClick={onSearch}>
                  <SearchIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Box>

      {identifiedItem ? (
        <Box
          sx={{
            mt: 1,
            p: 1.25,
            border: '1px solid',
            borderColor: 'divider',
            borderRadius: 1,
            bgcolor: 'white',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1 }}>
            <Typography variant="subtitle2" fontWeight={600} sx={{ wordBreak: 'break-word' }}>
              {identifiedItem?.itemCode} - {identifiedItem?.item?.itemName ?? identifiedItem?.itemName ?? ''}
            </Typography>
            <IconButton size="small" color="error" aria-label="Felismert cikk törlése" onClick={onClearIdentified}>
              <DeleteOutlineIcon fontSize="small" />
            </IconButton>
          </Box>
          {identifiedItem?.batchSn ? (
            <Typography variant="caption" color="text.secondary" component="div" sx={{ mt: 0.25 }}>
              Sarzs: {identifiedItem.batchSn}
            </Typography>
          ) : null}
          {identifiedItem?.binCode ? (
            <Typography variant="caption" color="text.secondary" component="div" sx={{ mt: 0.25 }}>
              Rakhely: {identifiedItem.binCode}
            </Typography>
          ) : null}

          <Box sx={{ mt: 1, display: 'flex', alignItems: 'center', gap: 1 }}>
            <InputUI
              name="identifiedQty"
              type="number"
              size="small"
              sx={{ width: 120 }}
              inputProps={{ min: 0, step: quantityInputStep ?? '1' }}
              value={identifiedQty}
              onChange={(e) => onIdentifiedQtyChange(e.target.value)}
              onBlur={onIdentifiedQtyBlur}
              onKeyDown={(e) => {
                if (e.key !== 'Enter') return;
                e.preventDefault();
                onConfirmItem();
              }}
              inputRef={qtyInputRef}
            />
            <Typography variant="body2" color="text.secondary">
              {identifiedQtyUnitCode}
            </Typography>
            <ButtonUI text="Tétel rögzítése" className="bg-success" onClick={onConfirmItem} />
          </Box>

          <Typography
            variant="caption"
            color={isOverStockLimit ? 'error.main' : 'text.secondary'}
            component="div"
            sx={{ mt: 0.75 }}
          >
            Készleten: {identifiedStockQty} {identifiedQtyUnitCode} | Rögzített: {alreadyRecordedQty}{' '}
            {identifiedQtyUnitCode} | Rögzíthető: {openQty} {identifiedQtyUnitCode}
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
};

export default ItemOutgoing;
